/**
 * UTILS — Shared pure utility functions. No side effects, no DOM, no state.
 */

export function formatPrice(number) {
  if (typeof number !== 'number') return '۰ تومان';
  return number.toLocaleString('fa-IR') + ' تومان';
}

export function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/[&<>'"]/g,
    tag => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[tag] || tag)
  );
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/** Cache product images in localStorage so they don't re-download on refresh */
export const ImageCache = {
  _key: 'SAFRAN_IMG_CACHE',

  async preload(urls) {
    const stored = this._load();
    const missing = urls.filter(u => u && !stored[u]);
    if (missing.length === 0) return;

    await Promise.allSettled(missing.map(url => this._fetchAndStore(url, stored)));
    this._save(stored);
  },

  async _fetchAndStore(url, cache) {
    try {
      const res  = await fetch(url);
      if (!res.ok) return;
      const blob = await res.blob();
      await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload  = () => { cache[url] = reader.result; resolve(); };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (_) { /* network error — skip silently */ }
  },

  get(url) {
    if (!url) return null;
    return this._load()[url] || null;
  },

  _load() {
    try { return JSON.parse(localStorage.getItem(this._key) || '{}'); }
    catch (_) { return {}; }
  },

  _save(cache) {
    try {
      // Keep localStorage under ~4MB: evict oldest entries if needed
      let json = JSON.stringify(cache);
      while (json.length > 4 * 1024 * 1024) {
        const firstKey = Object.keys(cache)[0];
        if (!firstKey) break;
        delete cache[firstKey];
        json = JSON.stringify(cache);
      }
      localStorage.setItem(this._key, json);
    } catch (_) { /* quota exceeded — skip */ }
  },
};
